export default function OpenMenu() {
  return (
    <svg className="w-10 h-10" width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7577 23.18H20.4909L22.54 20.283H11.27H0L2.41451 23.18H10.7577Z" fill="white"/>
      <path d="M10.5187 13.0385H22.5401V10.1415H11.0196H9.17155e-05V13.0385H10.5187Z" fill="white"/>
      <path d="M11.0902 -6.05194e-06L2.01641 -6.05194e-06L3.8147e-05 2.89709L11.27 2.89709L22.54 2.89709L20.164 -6.05194e-06L11.0902 -6.05194e-06Z" fill="white"/>
    </svg>
  )
}